import { render, staticRenderFns } from "./PsAdministrationBtnNewTransaction.vue?vue&type=template&id=c744b1be&scoped=true&"
import script from "./PsAdministrationBtnNewTransaction.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationBtnNewTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationBtnNewTransaction.vue?vue&type=style&index=0&id=c744b1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c744b1be",
  null
  
)

export default component.exports